var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.7175 0 0 6.71625 0 15C0 21.6275 4.2975 27.25 10.2587 29.2337C11.0075 29.3725 11.25 28.9075 11.25 28.5125V25.72C7.0775 26.6275 6.20875 23.95 6.20875 23.95C5.52625 22.2162 4.5425 21.755 4.5425 21.755C3.18125 20.8237 4.64625 20.8437 4.64625 20.8437C6.1525 20.9487 6.945 22.39 6.945 22.39C8.2825 24.6825 10.4538 24.02 11.31 23.6363C11.4438 22.6675 11.8325 22.005 12.2625 21.6313C8.93125 21.25 5.42875 19.9637 5.42875 14.2175C5.42875 12.5787 6.015 11.2412 6.97375 10.1912C6.81875 9.8125 6.305 8.28625 7.12 6.22125C7.12 6.22125 8.38 5.81875 11.2462 7.75875C12.4425 7.42625 13.725 7.26 15 7.25375C16.275 7.26 17.5587 7.42625 18.7575 7.75875C21.6212 5.81875 22.8787 6.22125 22.8787 6.22125C23.695 8.2875 23.1812 9.81375 23.0262 10.1912C23.9887 11.2412 24.57 12.58 24.57 14.2175C24.57 19.9787 21.0612 21.2475 17.7213 21.6188C18.2588 22.0838 18.75 22.9963 18.75 24.3963V28.5125C18.75 28.9112 18.99 29.38 19.7512 29.2325C25.7075 27.2462 30 21.625 30 15C30 6.71625 23.2837 0 15 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.0d6b6239.svg";
export { ForwardRef as ReactComponent };